import CheckmarkAnimationUrl from '@assets/checkmark-animation.gif';
import { VisibilityStates } from '@racemap/utilities/consts/events';
import { isChildEvent } from '@racemap/utilities/functions/utils';
import { Button, Typography } from 'antd';
import { useCurrentEvent } from 'src/lib/customHooks/useCurrentEvent';
import { useIsSafemap } from 'src/lib/customHooks/useIsSafemap';
import { useStore } from '../../../store/reducers';
import VisibilitySection from '../../VisibilitySection';
import type { ViewSlots } from './useOverviewView';

const { Title } = Typography;

interface Args {
  onClose: () => void;
}

export const useDoneView = ({ onClose }: Args): ViewSlots | null => {
  const currentEvent = useCurrentEvent();
  const isSafemap = useIsSafemap();
  const { updateEvent } = useStore((s) => s.events.actions);

  if (currentEvent == null) return null;

  return {
    title: 'Payment complete',
    body: (
      <div style={{ textAlign: 'center' }}>
        <img
          src={CheckmarkAnimationUrl}
          alt="Checkmark animation"
          style={{ width: 200, height: 200 }}
        />
        {!isChildEvent(currentEvent) && !isSafemap && (
          <>
            <p>
              <Title level={4}>Select the visibility of your Tracking Map</Title>
            </p>
            <VisibilitySection
              value={currentEvent.visibility}
              onChange={(newValue) => {
                updateEvent(currentEvent.id, [{ key: 'visibility', newValue }]);
              }}
              authorized
              possibleStates={Object.values(VisibilityStates).filter(
                (e) => e !== VisibilityStates.PUBLIC && e !== VisibilityStates.ARCHIVED,
              )}
            />
          </>
        )}
      </div>
    ),
    footer: <Button onClick={onClose}>Close</Button>,
  };
};
